import { useState } from 'react';
import './MenuTransitionTest.scss';

export function MenuTransitionTest() {
    const [activeVariants, setActiveVariants] = useState({
        variant1: { men: false, beauty: false },
        variant2: { men: false, beauty: false },
        variant3: { men: false, beauty: false },
        variant4: { men: false, beauty: false },
        variant5: { men: false, beauty: false },
    });

    const [nestedStates, setNestedStates] = useState({
        variant1: { menTopwear: false },
        variant2: { menTopwear: false },
        variant3: { menTopwear: false },
        variant4: { menTopwear: false },
        variant5: { menTopwear: false },
    });

    const menuData = {
        men: {
            children: [
                {
                    name: 'Topwear',
                    subChildren: ['T-Shirts', 'Shirts', 'Kurtas']
                },
                'Bottomwear',
                'Footwear'
            ]
        },
        beauty: {
            children: ['Makeup', 'Baby Care', 'Masks']
        }
    };

    const toggleMenu = (variant, menuName) => {
        setActiveVariants(prev => ({
            ...prev,
            [variant]: {
                ...prev[variant],
                [menuName]: !prev[variant][menuName]
            }
        }));
    };

    const toggleNested = (variant, menuName) => {
        setNestedStates(prev => ({
            ...prev,
            [variant]: {
                ...prev[variant],
                [menuName]: !prev[variant][menuName]
            }
        }));
    };

    const MenuItem = ({ variant, menuName, children, subChildren, variantName }) => {
        const isOpen = activeVariants[variant][menuName];
        const nestedKey = `${menuName}Topwear`;
        const isNestedOpen = nestedStates[variant][nestedKey];

        return (
            <div className={`menu-item variant-${variant}`}>
                <div 
                    className="menu-header" 
                    onClick={() => toggleMenu(variant, menuName)}
                >
                    <span className="menu-title">{menuName}</span>
                    <svg 
                        width="16" 
                        height="16" 
                        viewBox="0 0 24 24" 
                        fill="#a9abb3" 
                        className={`arrow-icon ${isOpen ? 'open' : ''}`}
                    >
                        <g fill="none" fillRule="evenodd">
                            <path d="M0 0h24v24H0z" opacity="0.05"></path>
                            <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                        </g>
                    </svg>
                </div>

                {/* Variant 1: Max-Height + Opacity */}
                {variant === 'variant1' && (
                    <div 
                        className={`children-container variant1 ${isOpen ? 'open' : 'closed'}`}
                    >
                        {children.map((child, idx) => (
                            <div key={idx}>
                                {typeof child === 'object' ? (
                                    <>
                                        <div 
                                            className="child-item has-children"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleNested(variant, nestedKey);
                                            }}
                                        >
                                            <span>{child.name}</span>
                                            <svg 
                                                width="14" 
                                                height="14" 
                                                viewBox="0 0 24 24" 
                                                fill="#a9abb3"
                                                className={`arrow-icon-small ${isNestedOpen ? 'open' : ''}`}
                                            >
                                                <g fill="none" fillRule="evenodd">
                                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                    <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`nested-children variant1 ${isNestedOpen ? 'open' : 'closed'}`}>
                                            {child.subChildren.map((sub, subIdx) => (
                                                <div key={subIdx} className="nested-item">{sub}</div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="child-item">{child}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Variant 2: Transform + Opacity */}
                {variant === 'variant2' && (
                    <div className={`children-container variant2 ${isOpen ? 'open' : 'closed'}`}>
                        {children.map((child, idx) => (
                            <div key={idx}>
                                {typeof child === 'object' ? (
                                    <>
                                        <div 
                                            className="child-item has-children"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleNested(variant, nestedKey);
                                            }}
                                        >
                                            <span>{child.name}</span>
                                            <svg 
                                                width="14" 
                                                height="14" 
                                                viewBox="0 0 24 24" 
                                                fill="#a9abb3"
                                                className={`arrow-icon-small ${isNestedOpen ? 'open' : ''}`}
                                            >
                                                <g fill="none" fillRule="evenodd">
                                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                    <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`nested-children variant2 ${isNestedOpen ? 'open' : 'closed'}`}>
                                            {child.subChildren.map((sub, subIdx) => (
                                                <div key={subIdx} className="nested-item">{sub}</div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="child-item">{child}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Variant 3: CSS Grid */}
                {variant === 'variant3' && (
                    <div className={`children-container variant3 ${isOpen ? 'open' : 'closed'}`}>
                        {children.map((child, idx) => (
                            <div key={idx}>
                                {typeof child === 'object' ? (
                                    <>
                                        <div 
                                            className="child-item has-children"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleNested(variant, nestedKey);
                                            }}
                                        >
                                            <span>{child.name}</span>
                                            <svg 
                                                width="14" 
                                                height="14" 
                                                viewBox="0 0 24 24" 
                                                fill="#a9abb3"
                                                className={`arrow-icon-small ${isNestedOpen ? 'open' : ''}`}
                                            >
                                                <g fill="none" fillRule="evenodd">
                                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                    <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`nested-children variant3 ${isNestedOpen ? 'open' : 'closed'}`}>
                                            {child.subChildren.map((sub, subIdx) => (
                                                <div key={subIdx} className="nested-item">{sub}</div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="child-item">{child}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Variant 4: Scale + Opacity */}
                {variant === 'variant4' && (
                    <div className={`children-container variant4 ${isOpen ? 'open' : 'closed'}`}>
                        {children.map((child, idx) => (
                            <div key={idx}>
                                {typeof child === 'object' ? (
                                    <>
                                        <div 
                                            className="child-item has-children"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleNested(variant, nestedKey);
                                            }}
                                        >
                                            <span>{child.name}</span>
                                            <svg 
                                                width="14" 
                                                height="14" 
                                                viewBox="0 0 24 24" 
                                                fill="#a9abb3"
                                                className={`arrow-icon-small ${isNestedOpen ? 'open' : ''}`}
                                            >
                                                <g fill="none" fillRule="evenodd">
                                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                    <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`nested-children variant4 ${isNestedOpen ? 'open' : 'closed'}`}>
                                            {child.subChildren.map((sub, subIdx) => (
                                                <div key={subIdx} className="nested-item">{sub}</div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="child-item">{child}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Variant 5: Height + Opacity (Smooth) */}
                {variant === 'variant5' && (
                    <div className={`children-container variant5 ${isOpen ? 'open' : 'closed'}`}>
                        {children.map((child, idx) => (
                            <div key={idx}>
                                {typeof child === 'object' ? (
                                    <>
                                        <div 
                                            className="child-item has-children"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleNested(variant, nestedKey);
                                            }}
                                        >
                                            <span>{child.name}</span>
                                            <svg 
                                                width="14" 
                                                height="14" 
                                                viewBox="0 0 24 24" 
                                                fill="#a9abb3"
                                                className={`arrow-icon-small ${isNestedOpen ? 'open' : ''}`}
                                            >
                                                <g fill="none" fillRule="evenodd">
                                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                    <path fill="#a9abb3" d="M12.55 15.768a.786.786 0 00.041-.048l6.183-6.36a.815.815 0 000-1.128.761.761 0 00-1.095 0l-5.68 5.844-5.678-5.844a.761.761 0 00-1.095 0 .816.816 0 000 1.127l6.182 6.361A.761.761 0 0012 16a.76.76 0 00.55-.232"></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div className={`nested-children variant5 ${isNestedOpen ? 'open' : 'closed'}`}>
                                            {child.subChildren.map((sub, subIdx) => (
                                                <div key={subIdx} className="nested-item">{sub}</div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div className="child-item">{child}</div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="menu-transition-test">
            <div className="test-header">
                <h1>Menu Transition Test Page</h1>
                <p>Click on "Men" or "Beauty" to see different transition effects</p>
            </div>

            <div className="variants-container">
                {/* Variant 1: Max-Height + Opacity */}
                <div className="variant-section">
                    <h2>Variant 1: Max-Height + Opacity</h2>
                    <p className="variant-description">Smooth expand/collapse with opacity fade</p>
                    <div className="menu-container">
                        <MenuItem 
                            variant="variant1" 
                            menuName="men" 
                            children={menuData.men.children}
                            variantName="Max-Height + Opacity"
                        />
                        <MenuItem 
                            variant="variant1" 
                            menuName="beauty" 
                            children={menuData.beauty.children}
                            variantName="Max-Height + Opacity"
                        />
                    </div>
                </div>

                {/* Variant 2: Transform + Opacity */}
                <div className="variant-section">
                    <h2>Variant 2: Transform + Opacity</h2>
                    <p className="variant-description">Slide down with fade effect</p>
                    <div className="menu-container">
                        <MenuItem 
                            variant="variant2" 
                            menuName="men" 
                            children={menuData.men.children}
                            variantName="Transform + Opacity"
                        />
                        <MenuItem 
                            variant="variant2" 
                            menuName="beauty" 
                            children={menuData.beauty.children}
                            variantName="Transform + Opacity"
                        />
                    </div>
                </div>

                {/* Variant 3: CSS Grid */}
                <div className="variant-section">
                    <h2>Variant 3: CSS Grid</h2>
                    <p className="variant-description">Modern grid-based transition</p>
                    <div className="menu-container">
                        <MenuItem 
                            variant="variant3" 
                            menuName="men" 
                            children={menuData.men.children}
                            variantName="CSS Grid"
                        />
                        <MenuItem 
                            variant="variant3" 
                            menuName="beauty" 
                            children={menuData.beauty.children}
                            variantName="CSS Grid"
                        />
                    </div>
                </div>

                {/* Variant 4: Scale + Opacity */}
                <div className="variant-section">
                    <h2>Variant 4: Scale + Opacity</h2>
                    <p className="variant-description">Zoom in/out effect with fade</p>
                    <div className="menu-container">
                        <MenuItem 
                            variant="variant4" 
                            menuName="men" 
                            children={menuData.men.children}
                            variantName="Scale + Opacity"
                        />
                        <MenuItem 
                            variant="variant4" 
                            menuName="beauty" 
                            children={menuData.beauty.children}
                            variantName="Scale + Opacity"
                        />
                    </div>
                </div>

                {/* Variant 5: Max-Height + Opacity (Smooth Easing) */}
                <div className="variant-section">
                    <h2>Variant 5: Max-Height + Opacity (Smooth Easing)</h2>
                    <p className="variant-description">Max-height with cubic-bezier easing for smoother feel</p>
                    <div className="menu-container">
                        <MenuItem 
                            variant="variant5" 
                            menuName="men" 
                            children={menuData.men.children}
                            variantName="Height + Opacity"
                        />
                        <MenuItem 
                            variant="variant5" 
                            menuName="beauty" 
                            children={menuData.beauty.children}
                            variantName="Height + Opacity"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

